import { useCallback } from "react";

import { usePersistDraft } from "@RequestFormV2/hooks/usePersistDraft";

export function usePersistScheduleDraft() {
  const persistDraft = usePersistDraft();
  return useCallback(() => persistDraft("schedule"), [persistDraft]);
}
